import { render } from "./room_section.vue?vue&type=template&id=d644810c"
import script from "./room_section.vue?vue&type=script&lang=js"
export * from "./room_section.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__